// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__38UpL","approved":"Status_approved__3a3XN","rejected":"Status_rejected__3IRjL","expired":"Status_expired__1as7G","label":"Status_label__3fRSX"};